import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WebUserComponent } from './web-user.component';

const routes: Routes = [
  {
    path:'',
    component: WebUserComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WebUserRoutingModule { }
